import React from "react";

const TerminatedIcon = ({ cls }) => {
  return (
    <svg
      width="26"
      height="25"
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <g clipPath="url(#clip0_3310_53183)">
        <path
          d="M20.8524 5.76669L17.2232 2.13544C16.5475 1.45642 15.7439 0.918077 14.8589 0.551544C13.9738 0.185011 13.0249 -0.00244154 12.067 2.4009e-05H7.36385C5.98302 0.00167803 4.65922 0.550943 3.68283 1.52734C2.70644 2.50373 2.15717 3.82753 2.15552 5.20836V19.7917C2.15717 21.1725 2.70644 22.4963 3.68283 23.4727C4.65922 24.4491 5.98302 24.9984 7.36385 25H17.7805C19.1613 24.9984 20.4851 24.4491 21.4615 23.4727C22.4379 22.4963 22.9872 21.1725 22.9888 19.7917V10.9219C22.9914 9.96401 22.8039 9.01512 22.4372 8.13021C22.0705 7.24529 21.5318 6.44194 20.8524 5.76669ZM19.3795 7.23961C19.6976 7.56684 19.9711 7.9346 20.193 8.33336H15.6972C15.4209 8.33336 15.156 8.22361 14.9606 8.02826C14.7653 7.83291 14.6555 7.56796 14.6555 7.29169V2.79586C15.0544 3.01765 15.4225 3.29082 15.7503 3.60836L19.3795 7.23961ZM20.9055 19.7917C20.9055 20.6205 20.5763 21.4153 19.9902 22.0014C19.4042 22.5875 18.6093 22.9167 17.7805 22.9167H7.36385C6.53505 22.9167 5.74019 22.5875 5.15414 22.0014C4.56809 21.4153 4.23885 20.6205 4.23885 19.7917V5.20836C4.23885 4.37956 4.56809 3.5847 5.15414 2.99865C5.74019 2.4126 6.53505 2.08336 7.36385 2.08336H12.067C12.2378 2.08336 12.4034 2.11669 12.5722 2.13232V7.29169C12.5722 8.12049 12.9014 8.91535 13.4875 9.5014C14.0735 10.0875 14.8684 10.4167 15.6972 10.4167H20.8566C20.8722 10.5854 20.9055 10.75 20.9055 10.9219V19.7917Z"
          fill="currentColor"
        />
        <g clipPath="url(#clip1_3310_53183)">
          <path
            d="M17.3396 11.7136C17.1906 11.5646 16.9886 11.481 16.7779 11.481C16.5672 11.481 16.3651 11.5646 16.2161 11.7136L12.5723 15.3574L8.92841 11.7136C8.77941 11.5646 8.57735 11.481 8.36666 11.481C8.15597 11.481 7.9539 11.5646 7.8049 11.7136C7.65595 11.8626 7.57227 12.0647 7.57227 12.2753C7.57227 12.486 7.65595 12.6881 7.8049 12.8371L11.4488 16.481L7.8049 20.1248C7.65595 20.2738 7.57227 20.4759 7.57227 20.6866C7.57227 20.8973 7.65595 21.0993 7.8049 21.2483C7.9539 21.3973 8.15597 21.481 8.36666 21.481C8.57735 21.481 8.77941 21.3973 8.92841 21.2483L12.5723 17.6045L16.2161 21.2483C16.3651 21.3973 16.5672 21.481 16.7779 21.481C16.9886 21.481 17.1906 21.3973 17.3396 21.2483C17.4886 21.0993 17.5723 20.8973 17.5723 20.6866C17.5723 20.4759 17.4886 20.2738 17.3396 20.1248L13.6958 16.481L17.3396 12.8371C17.4886 12.6881 17.5723 12.486 17.5723 12.2753C17.5723 12.0647 17.4886 11.8626 17.3396 11.7136Z"
            fill="currentColor"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3310_53183">
          <rect
            width="25"
            height="25"
            fill="white"
            transform="translate(0.0721436)"
          />
        </clipPath>
        <clipPath id="clip1_3310_53183">
          <rect
            width="10.11"
            height="10.11"
            fill="white"
            transform="translate(7.51721 11.3711)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TerminatedIcon;
